
import { Component, mixins } from '@niknevis/vue-modules'
import AdminContentItemRow from '@/modules/content-item/components/admin/table/AdminContentItemRow.vue'
import { InjectReactive } from 'vue-property-decorator'
import { ContentCampaignResourceTypeInAdmin } from '@/modules/content-campaign/models/content-campaign-resource.model'

@Component
export default class AdminContentCampaignItemsTableRow extends mixins<AdminContentItemRow>(AdminContentItemRow) {
  @InjectReactive()
  contentCampaign!: ContentCampaignResourceTypeInAdmin

  get withData() {
    return {
      statuses: this.contentCampaign.item_statuses,
    }
  }
}
